export const DEV = window.location.hostname === 'localhost';




export const API_URL = DEV ? 'https://agest-backend.test/api' : localStorage.getItem('dev') == 'true' ? 'https://dev-api.asoft.es/api' : 'https://api.asoft.es/api';



export async function Get({ request }) {
    return await apirequest({
        request: request,
        method: "GET"
    }).catch((e) => {
        console.log(e);
        throw e;
    })

}

export async function Post({ request, data, debug }) {
    if (debug) {
        console.log('[ POST API ]', request, data)
    }
    return await apirequest({
        request: request,
        body: data,
        method: "POST",
        debug
    })
}

export async function Put({ request, data }) {
    return await apirequest({
        request: request,
        body: data,
        method: "PUT"
    })
}

export async function Delete({ request }) {
    return await apirequest({
        request: request,
        method: "DELETE"
    })
}
//create a function that sends a file to the server using post method and multipart/form-data
export async function uploadFile({
    data, file, method = "POST", request, debug
}) {
    const formData = new FormData();
    formData.append('file', file);

    const headers = new Headers();
    headers.append("Authorization", "Bearer " + localStorage.getItem("token"));


    const options = {
        method: method,
        headers,
        body: formData
    };
    if (debug) {
        console.log("[ API REQUEST ]", API_URL + request, data, file)
    }
    try {
        let r = await fetch(API_URL + request, options)
            .then(response => response.json())
            .then(json => json)
            .catch(error => {
                if (debug) {
                    console.log("[ API REQUEST ERROR ]", error)
                }
            });
        return r
    } catch (error) {
        if (debug) {
            console.log("[ API REQUEST ERROR ]", error)
        }
    }
}


async function apirequest({
    body, method = "POST", request, debug
}) {

    const headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    headers.append("Authorization", "Bearer " + localStorage.getItem("token"));

    const options = {
        method: method,
        headers,
        body: body ? new URLSearchParams(body) : null,
    };
    if (debug) {
        console.log("[ API REQUEST ]", API_URL + request, body)
    }
    try {
        let r = await fetch(API_URL + request, options)
            .then(response => response.json())
            .then(json => json)
            .catch(error => {
                if (debug) {
                    console.log("[ API REQUEST ERROR ]", error)
                }
                throw error;
            });
        return r
    } catch (error) {
        if (debug) {
            console.log("[ API REQUEST ERROR ]", error)
        }
        throw error;
    }


}